<template>
  <div class="search_left full_height">
    <div class="common_search">
      <div class="inlineBlock">
        <el-select v-model="moduleSearch" placeholder="Please choose" @change="changeSelectSearch">
          <el-option
            v-for="item in searchOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="inlineBlock">
        <el-input
          placeholder="Please enter content"
          v-model="keyword"
          class="input-with-select"
          @keyup.enter.native="searchData"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </div>
    </div>

    <div class="components common_left">
      <component
        :is="currentCom"
        ref="com"
        :lists="commonList"
        :total="total"
        v-if="currentCom"
        @search="commonSearch"
        @changRightStatus="changRightStatus"
      >
        <template slot="tag">
          <span class="tag_item_left">{{comName}}</span>
        </template>
      </component>
      <div v-else class="no_data_container">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>
  </div>
</template>

<script>
import searchOptions from "../../conf/SearchOptions";
import {
  getCompanyList,
  getZephyrList,
  getIndictorsList,
  getMacroCommon
} from "common/js/http/v2Api";

// 根据后台字段 修改   组件
const comMap = {
  Macro: "Macro",
  Industry: "Industry",
  Company: "Company",
  "M&A transactions": "Transaction"
};

export default {
  name: "DataLeft",
  // props:["title","name"],
  data() {
    return {
      searchOptions,
      moduleSearch: "",
      keyword: "",
      currentCom: "",
      comName: "",
      // 组件search相关
      commonList: [],
      total: 0,
      commonQuery: {},
      macroSearchIndex: 0,
      isMobilePhone: false
    };
  },

  created() {
    this.initModule();
  },

  methods: {
    initModule() {
      this.moduleSearch = "Company";
      this.changeSelectSearch();
    },

    changeSelectSearch() {
      this.keyword = "";
      this.macroSearchIndex = 0;
      this.comName = comMap[this.moduleSearch];
      this.currentCom = this.requireComponents(this.comName);
    },

    searchData() {
      // this.comName = comMap[this.moduleSearch];
      // console.log("TCL: searchData -> this.comName", this.comName)
      // this.currentCom = this.requireComponents(this.comName);
      // this.$router.push(`/data/SearchModule/${this.comName}`);
      const map = {
        Macro: "macroSearch",
        Industry: "industrySearch",
        Company: "companySearch",
        "M&A transactions": "transcationSearch"
      };
      const fn = map[this.moduleSearch];
      this.commonQuery.keyword = this.keyword;
      this[fn]();
    },

    requireComponents(com) {
      const component = resolve =>
        require([
          `@/views/silkRoadV2Data/components/mobile/comLeft/${com}`
        ], resolve);
      return component;
    },

    commonSearch(key, value) {
      this.commonQuery = Object.assign(this.$lodash.cloneDeep(value), {
        keyword: this.keyword
      });
      if (key == "macro") {
        //默认第一次 关键字GDP  输入栏不能显示 所以不能直接指定this.keyword
        if (this.macroSearchIndex == 0) {
          this.commonQuery.keyword = "GDP";
        }
        this.macroSearchIndex++;
      }

      const keyFn = key + "Search";
      this[keyFn](value);
    },

    // 企业列表emit
    async companySearch(val) {
      const { result } = await getCompanyList(this.commonQuery);
      this.commonList = result.recordList;
      this.total = result.recordCount;
    },

    // 并购交易
    async transcationSearch(val) {
      const { result } = await getZephyrList(this.commonQuery);
      result.recordList.forEach(item => {
        try {
          //数据包含json 或者字符串要分开处理  避免数据原因造成程序报错 返回[]
          if (item.target.includes("{") && item.target.includes("}")) {
            item.target = JSON.parse(item.target).map(item => item.target_name);
            item.vendor = JSON.parse(item.vendor).map(item => item.vendor_name);
            item.acquiror = JSON.parse(item.acquiror).map(
              item => item.acquiror_name
            );
          } else {
            item.target = item.target.split(",").map(item => {
              const itemData = item.split(";");
              let target = "";
              itemData.forEach(j => {
                if (j.includes("target_name")) {
                  target = j.split(":")[1];
                }
              });
              return target;
            });
            item.vendor = item.vendor.split(",").map(item => {
              const itemData = item.split(";");
              let target = "";
              itemData.forEach(j => {
                if (j.includes("vendor_name")) {
                  target = j.split(":")[1];
                }
              });
              return target;
            });
            item.acquiror = item.acquiror.split(",").map(item => {
              const itemData = item.split(";");
              let target = "";
              itemData.forEach(j => {
                if (j.includes("acquiror_name")) {
                  target = j.split(":")[1];
                }
              });
              return target;
            });
          }
        } catch (error) {
          item.target = [];
          item.vendor = [];
          item.acquiror = [];
        }
      });
      this.commonList = result.recordList;
      this.total = result.recordCount;
    },

    async industrySearch(val) {
      const level = "3"; //后台固定数值
      const query = Object.assign(this.$lodash.cloneDeep(this.commonQuery), {
        name: this.keyword,
        level
      });
      const { result } = await getIndictorsList(query);
      this.total = result.total;

      // result.list.forEach(item => {

      // });

      this.commonList = result.list;
    },

    // Annual,%20ending%20"Dec"%20of%20each%20year
    // Annual,%20ending%20"Dec"%20of%20each%20year

    // Annual,%20ending%20%22Dec%22%20of%20each%20year
    async macroSearch(val) {
      const params = {
        api: "/api/queryAll.html",
        methodType: "POST",
        params: this.commonQuery,
        userId: parseInt(this.Cookies.get("imsilkroad_userid")),
        userName: this.Cookies.get("imsilkroad_username")
        // userId: 1,
        // userName: "test"
      };

      const { data } = await getMacroCommon(params);
      this.total = data.total;

      const list = data.hits.map(item => ({
        id: item._id,
        name: item._source.cn_name,
        fullName:
          item._source.cn_name + ":" + item._source.country_cn_simplename,
        countryName: item._source.country_cn_simplename,
        frequency: item._source.statperiod_cn_description,
        unit: item._source.unit_cn_description,
        resource: item._source.original_data_source
      }));
      this.commonList = list;
    },

    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },

    changRightStatus(key, val) {
      this.$emit("changRightStatus", key, val);
    }
  },

  watch: {
    $route(newValue) {
      const path = newValue.path.split("/");
      if (path.length == 3) {
        this.currentCom = "";
        this.moduleSearch = "";
      }
    }
  }
};
</script>

<style scoped>
.search_left {
  margin-right: 20px;
  background: #ffffff;
  border: 0 solid #4e5671;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}

.inlineBlock {
  display: inline-block;
  width: 50%;
  padding: 0px 10px;
}

.common_search {
  padding: 13px 0px 17px 0px;
  border-bottom: 1px solid #e1e1e1;
}

.inlineBlock >>> .input-with-select .el-input__inner {
  /*border-radius: 15px !important;*/
  /*border-right: none !important;*/
  /**/
  border-right: none !important;
  border-top-left-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
}

.inlineBlock >>> .el-input-group__append,
.inlineBlock >>> .el-input-group__prepend {
  /*border-radius:15px !important;*/
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
.inlineBlock >>> .el-input.is-active .el-input__inner,
.inlineBlock >>> .el-input__inner:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
}

.common_left {
  padding: 15px;
  height: 100%;
}
@media screen and (max-width: 762px) {
  .search_left {
    margin-right: 0px;
  }
}
</style>